var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"auth-form"},[_c('AuthPageHeader',{attrs:{"title":"Confirm Email Address"}}),_c('p',[_vm._v("Click below to confirm your email address and activate your ThreeFlow account.")]),_c('div',{staticClass:"btn-group"},[_c('AppButton',{attrs:{"type":"primary","text":"Confirm email","no-branding":""}})],1),_c('AuthPageFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }